import { render, staticRenderFns } from "./AddItineraryBlockModal.vue?vue&type=template&id=20cbb104&"
import script from "./AddItineraryBlockModal.vue?vue&type=script&lang=js&"
export * from "./AddItineraryBlockModal.vue?vue&type=script&lang=js&"
import style0 from "./AddItineraryBlockModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports